import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { genNoticeStyle, prepareComponentToken, prepareNotificationToken } from '.';
import { genSubStyleComponent } from '../../theme/internal';
export default genSubStyleComponent(['Notification', 'PurePanel'], function (token) {
  var noticeCls = "".concat(token.componentCls, "-notice");
  var notificationToken = prepareNotificationToken(token);
  return _defineProperty({}, "".concat(noticeCls, "-pure-panel"), Object.assign(Object.assign({}, genNoticeStyle(notificationToken)), {
    width: notificationToken.width,
    maxWidth: "calc(100vw - ".concat(unit(token.calc(notificationToken.notificationMarginEdge).mul(2).equal()), ")"),
    margin: 0
  }));
}, prepareComponentToken);